import{get,post} from '@/api/index'
export const wronglist = params => get(`/api/paper/v1/wronglist`, params);//错题列表
export const colquelist = params => get(`/api/paper/v1/colquelist`, params);//收藏题列表
export const colparlist = params => get(`/api/paper/v1/colparlist`, params);//收藏试卷列表
export const delcollect = params => post(`/api/paper/v1/delcollect`, params);//删除收藏
export const answerlist = params => get(`/api/paper/v1/answerlist`, params);//练习历史
